<template>
  <div
    class="logo"
    :class="{ scrolled: $store.state.page.scrolled }"
    data-apollo-hover
    data-apollo-hover-animation="scale-center"
  >
    <router-link :to="`/${$store.state.lang}`" @click.native="$eventHub.$emit('close-menu')">
      <div class="logo__zonin">
        <img src="/static/vector/zonin.svg" alt="Zonin">
      </div>
      <div class="logo__prosecco">
        <img src="/static/vector/prosecco.svg" alt="Prosecco 1821">
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ComposedLogo',
};
</script>

<style lang="scss" scoped>
.logo {
  width: 100%;

  @include mq($until: ipadP) {
    width: 100px;
    margin: 0 auto;
  }

  img {
    height: calc(100px * var(--rw));
    margin: 0 auto;
    filter: saturate(0%) brightness(200%);
    transition: filter .6s $inOutCubic;

    @at-root .menu-open & {
      filter: none;
    }

    @at-root .page-white & {
      filter: saturate(0%) brightness(0%);
    }

    // Fix for loader not changin color keep white
    @at-root .loader & {
      filter: saturate(0%) brightness(200%);
    }
  }

  &__zonin {
    transition: transform .6s $inOutCubic;
  }

  &__prosecco {
    display: none;
    transform: scale(0.6) translateX(-3%) translateY(-15%);
    transition: transform .6s $inOutCubic,
                opacity .6s $inOutCubic;
  }

  &.scrolled {
    .logo__prosecco {
      transform: scale(0.6) translateX(-8%) translateY(30px);
      opacity: 0;

      @include mq($until: ipadP) {
        transform: translateY(100%);
      }
    }
  }
}
</style>
